/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 혜택 종류 (사용시 부여 되는 롤 등)
 */
export type SubscriptionCouponProfileBenefitType = 'SilverMember';

export const SubscriptionCouponProfileBenefitType = {
    SilverMember: 'SilverMember' as SubscriptionCouponProfileBenefitType
};

